import { useEffect, useState } from 'react'
import {
  BRIDGE_READY_EVENT,
  ensureLeapBridgeInit,
  initLeapBridge,
  isNativeBridgeAvailable,
} from '@/services/scanner/leapNativeBridge'

/** True when WebView or RFID Connector localhost WebSocket bridge is ready. */
export function useLeapBridgeReady(): boolean {
  const [ready, setReady] = useState(() => isNativeBridgeAvailable())

  useEffect(() => {
    ensureLeapBridgeInit()
    void initLeapBridge().then(() => setReady(isNativeBridgeAvailable()))

    const onReady = () => setReady(true)
    window.addEventListener(BRIDGE_READY_EVENT, onReady)
    return () => window.removeEventListener(BRIDGE_READY_EVENT, onReady)
  }, [])

  return ready
}
